import { translate } from '../../helpers/translate.helper';

export const getSurchargeOrWaiverString = (value: number) => {
    if (value >= 0) {
        return translate('order.surcharges.surcharge');
    }

    return translate('order.surcharges.waiver');
};
